import { createGlobalStyle } from 'styled-components';

// Define the path to the SVG directly
const fullscreenIconPath = '/assets/icons/fullscreen.svg';

// Using createGlobalStyle to target Leaflet's elements that are outside our component's scope
export const FullscreenControlStyles = createGlobalStyle`  .leaflet-container .leaflet-control .leaflet-fullscreen-icon {
    background-image: url(${fullscreenIconPath}) !important;
	background-size: 26px 52px !important;
  }

  .leaflet-touch .leaflet-fullscreen-icon {
    background-position: 2px 2px;
  }

  .leaflet-touch .leaflet-fullscreen-icon.leaflet-fullscreen-on {
    background-position: 2px -24px;
  }

  .leaflet-container:-webkit-full-screen,
  .leaflet-container:fullscreen {
    width: 100% !important;
    height: 100% !important;
    z-index: 99999;
  }

  .leaflet-pseudo-fullscreen {
    position: fixed !important;
    width: 100% !important;
    height: 100% !important;
    top: 0 !important;
    left: 0 !important;
    z-index: 99999;
  }
`;
